"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VentaLineaConverter = void 0;
const VentaLineaConverter = {
    toFirestore(linea) {
        return linea;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            cantidad: data.cantidad,
            descripcion: data.descripcion,
            descripcionLarga: data.descripcionLarga,
            rubro: data.rubro,
            centroCosto: data.centroCosto,
            tipo: data.tipo,
            tasaIva: data.tasaIva,
            montoBruto: data.montoBruto,
            descuentoMonto: data.descuentoMonto,
            descuentoPorcentaje: data.descuentoPorcentaje,
            esPrecioArbitrario: data.esPrecioArbitrario,
            precio: data.precio,
            precioOriginal: data.precioOriginal,
            importe: data.importe,
            stockProducto: data.stockProducto ?? null,
            idProducto: data.idProducto,
            idServicio: data.idServicio,
            listaPrecio: data.listaPrecio,
            retenciones: data.retenciones,
            codigo: data.codigo,
            stockLotes: data.stockLotes,
            cantRemito: data.remito ?? 0,
            idRemito: data.idRemito ?? null
        };
    }
};
exports.VentaLineaConverter = VentaLineaConverter;
